<template>
  <v-dialog
    v-model="dialog"
    scrollable
    max-width="700px"
    transition="dialog-transition"
  >
    <template #activator="{}">
      <v-btn :loading="loading" @click="OpenDialog" icon color="success">
        <v-icon>fas fa-user-cog</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-data-table :headers="head" :items="Trans" :loading="loading">
        <template v-slot:top>
          <v-toolbar flat color="grey lighten-4">
            <v-toolbar-title>{{ Info.CostName }}</v-toolbar-title>

            <v-divider class="mx-4" inset vertical></v-divider>
            <!-- <div class="flex-grow-1"></div> -->

            <div>
              <cashDisplay
                :isloading="loading"
                :Balance="TotalCash"
              ></cashDisplay>
            </div>
            <v-spacer></v-spacer>
            <v-btn @click="dialog = false" icon color="black">
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.Amount`]="{ item }">
          {{ (item.Amount * -1).toLocaleString() }}
          <strong>{{ item.AmountType | MoneySigns }}</strong>
        </template>
        <template v-slot:[`item.tran`]="{ item }">
          <cost-view :Info="{ ...Info, ...item }" :BaseUrl="BaseUrl">
          </cost-view>
        </template>
      </v-data-table>
      <v-card-actions>
        <supp-payment
          :Title="Info.CostName"
          :BaseURL="`${BaseUrl}/payment`"
          :OtherCost="Info"
          :ReloadFunc="() => null"
          :TotalCash="TotalCash"
        >
        </supp-payment>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
// import cashDisplay from "@/components/displayCash.vue";
import axios from "axios";
export default {
  components: {
    cashDisplay: () => import("@/components/util/displayCash.vue"),
    CostView: () => import("./SuppOrdeView"),
    SuppPayment: () => import("./SuppPayment"),
  },
  props: {
    // TotalCash: { type: Array, default: () => [] },
    Info: { type: Object, required: true },
    BaseUrl: { type: String, required: true },
    Title: { type: String, default: "This is the title" },
    head: {
      type: Array,
      default: () => [
        { text: "Order", value: "Reason" },
        { text: "Balance", value: "Amount" },
        { text: "Tran", value: "tran" },
      ],
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      Trans: [],
      TotalCash: [],
    };
  },
  methods: {
    AvailibleBalance() {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: `${this.BaseUrl}/balance`,
        query: {
          _id: this.Info._id,
        },
      });
    },
    TranSactions() {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: `${this.BaseUrl}/groupByReason`,
        query: {
          _id: this.Info._id,
        },
      });
    },
    OpenDialog() {
      // console.log(this.Info, this.BaseUrl);
      this.loading = true;
      axios
        .all([this.TranSactions(), this.AvailibleBalance()])
        .then(val => {
          this.loading = false;
          this.dialog = true;
          // console.log(val[1].data);
          this.Trans = val[0].data;
          this.TotalCash = val[1].data;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },
  },
};
</script>
